module.exports = __webpack_public_path__ + "img/tx_003.27f7aab2.png";